module.exports = __webpack_public_path__ + "static/media/coinmarketcap.4c27df13.png";